// extracted by mini-css-extract-plugin
export default {"img":"BubbleWpp_img__YSnA9","opacidad":"BubbleWpp_opacidad__tnygn"};